import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";

export default function Registro() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8 || !/[A-Za-zÁÉÍÓÚáéíóúÑñ]/.test(password) || !/\d/.test(password)) {
      setError("La contraseña debe tener al menos 8 caracteres e incluir letras y números");
      return;
    }
    setLoading(true);
    try {
      const user = await register(name, email, password);
      toast.success(`Bienvenido/a, ${user.name}. Tu cuenta fue creada.`);
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.detail || "No se pudo crear la cuenta. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto flex w-full max-w-md flex-col px-4 py-14 sm:py-20">
      <div className="mb-8 text-center">
        <img src="/brand/logo-gradient.png" alt="Tu Iglesia App" className="mx-auto h-20 w-auto" />
        <h1 className="mt-4 font-serif text-3xl font-semibold">Crea tu cuenta</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Es rápido. Tu participación puede animar a otros.
        </p>
      </div>
      <Card className="border-border bg-card shadow-[var(--shadow-sm)]">
        <CardContent className="p-6">
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <Label htmlFor="name">Nombre</Label>
              <Input
                id="name"
                required
                minLength={2}
                maxLength={80}
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Tu nombre"
                data-testid="auth-register-name-input"
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label htmlFor="email">Correo electrónico</Label>
              <Input
                id="email"
                type="email"
                required
                maxLength={254}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@correo.com"
                data-testid="auth-register-email-input"
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label htmlFor="password">Contraseña</Label>
              <Input
                id="password"
                type="password"
                required
                minLength={8}
                maxLength={128}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mínimo 8 caracteres, letras y números"
                data-testid="auth-register-password-input"
              />
              <p className="text-xs text-muted-foreground">Mínimo 8 caracteres, con letras y números.</p>
            </div>
            {error && (
              <p className="text-sm text-destructive" data-testid="auth-register-error">{error}</p>
            )}
            <Button type="submit" disabled={loading} data-testid="auth-register-submit-button">
              {loading ? "Creando cuenta…" : "Crear cuenta"}
            </Button>
          </form>
          <p className="mt-4 text-center text-sm text-muted-foreground">
            ¿Ya tienes cuenta?{" "}
            <Link to="/login" className="font-semibold text-primary hover:text-primary/80" data-testid="auth-go-login-link">
              Inicia sesión
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
